/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'

import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"

import offers from './offers'
import teamIntegration from './team-integration/moduleTeamIntegration'
import dataList from './data-list/moduleDataList'
import caps from './caps/moduleCaps'
import landings from './landings/index'
import prelandings from './prelandings/index'
import domains from './domains'
import campaigns from './campaigns/index'
import error from './error'
import leads from './leads'
import advertiserStatistics from './statistics/advertiser'
import management from './managemet'
import hold from './hold'
import geo from './geo'
import userManagement from './user-management/moduleUserManagement'
import teamLeads from './teamLead'
import affiliates from './affiliate'
import login from './login'
import deposits from './deposits'
import adv from './advertiser'
import financeStatistic from './financeStatistic'
import popup from './popup'
import servers from './servers'
import brand from "./brand"

Vue.use(Vuex)

export default new Vuex.Store({
    getters,
    mutations,
    state,
    actions,
    modules: {
        login,
        error,
        userManagement,
        landings,
        offers,
        caps,
        prelandings,
        domains,
        campaigns,
        teamIntegration,
        leads,
        advertiserStatistics,
        management,
        hold,
        geo,
        dataList,
        teamLeads,
        affiliates,
        deposits,
        adv,
        financeStatistic,
        popup,
        servers,
        brand
    },

    // strict: process.env.NODE_ENV !== 'production',
})
